var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "before-close": _vm.onClose,
        visible: _vm.isShow,
        center: "",
        "destroy-on-close": "",
        top: "21vh",
        width: "45%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c("div", [
        _vm.interType !== 1
          ? _c("div", [
              _c("div", { staticClass: "header_title u-m-b-20" }, [
                _vm._v(_vm._s(_vm.getTitle)),
              ]),
              _c("span", { staticClass: "u-font-weight-bold u-font-16" }, [
                _vm._v("温馨提示：您即将进入投保流程"),
              ]),
              _vm.isFgk(_vm.insureType) || _vm.isFgkDianti(_vm.insureType)
                ? _c(
                    "div",
                    {
                      staticClass: "u-m-t-5",
                      staticStyle: { "line-height": "24px" },
                    },
                    [
                      _vm._v("\n\t\t\t\t请仔细阅读\n\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("保险条款、客户告知"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t等内容，为保障您的权益，我们将会安全记录您的操作。\n\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t基于提供保险服务、提高理赔服务质量的需要，您授权：上海太平洋保险的合作机构“\n\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [_vm._v("IE保")]),
                      _vm._v(
                        "\n\t\t\t\t”在承保前或承保后以多种方式核实投保信息的真实性、调查获取被保险人与保险有关的相关信息，如上海太平洋保险经前述核查发现您存在未如实告知情况的，上海太平洋保险将依法解除保险合同；上海太平洋保险及上海太平洋保险的合作机构“\n\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [_vm._v("IE保")]),
                      _vm._v(
                        "\n\t\t\t\t”可对您的理赔信息进行合理获取及使用。为确保信息安全，上海太平洋及合作机构“\n\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [_vm._v("IE保")]),
                      _vm._v(
                        "\n\t\t\t\t”应采取有效措施，并承担保密义务。\n\t\t\t"
                      ),
                    ]
                  )
                : _c("div", { staticClass: "u-m-t-5" }, [
                    _vm._v("\n\t\t\t\t请仔细阅读\n\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v("保险条款、客户告知"),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t等内容，为保障您的权益，我们将会安全记录您的操作\n\t\t\t"
                    ),
                  ]),
            ])
          : _c("div", [
              _c("div", {
                staticClass: "html-content",
                domProps: { innerHTML: _vm._s(_vm.htmlContent) },
              }),
            ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onClose } }, [_vm._v("不同意")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onNext } },
            [_vm._v("已知悉并同意")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }